<div class="error-element" >
    <div class="error-message bottom">
        <ng-content></ng-content>
    </div>
</div>